import { MessageCircle } from 'lucide-react';
import { useSiteConfig } from '@/contexts/SiteConfigContext';

/** Shown when `connectWhatsappUrl` is set in public site settings (Edit public site → Branding). */
export function WhatsAppFloat() {
  const { config } = useSiteConfig();
  const href = config?.connectWhatsappUrl?.trim();
  if (!href) return null;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed z-[45] right-5 bottom-24 md:bottom-28 flex items-center gap-2 rounded-full bg-[#25D366] text-white pl-4 pr-5 py-3 shadow-lg hover:bg-[#20bd5a] hover:shadow-xl transition-all focus:outline-none focus-visible:ring-2 focus-visible:ring-white/80"
      aria-label="Chat on WhatsApp"
    >
      <span className="flex h-9 w-9 items-center justify-center rounded-full bg-white/20">
        <MessageCircle className="w-5 h-5" strokeWidth={2} />
      </span>
      <span className="text-sm font-semibold tracking-tight pr-0.5">Chat on WhatsApp</span>
    </a>
  );
}
